import { useEffect } from 'react';

import { visitDailyBonus } from '@/redux/reducers/userReducer';
import { useAppDispatch, useAppSelector } from '@/redux/store';

const useVisitDailyBonus = (): void => {
  const hasDailyBonusVisit = useAppSelector(
    (state) => state.user.hasDailyBonusVisit,
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!hasDailyBonusVisit) {
      const now = new Date();
      localStorage.setItem('dailyBonusLastVisitTime', now.toISOString());
      dispatch(visitDailyBonus());
    }
  }, [hasDailyBonusVisit]);
};

export { useVisitDailyBonus };
